import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Select, SelectPropTypes, SelectDefaultProps } from 'site-modules/shared/components/select/select';
import { isSelectDisabled } from 'site-modules/shared/components/select/utils';

import './styled-select.scss';

// Select with the blue arrow
const StyledSelectUI = (
  {
    size = null,
    wrapperClassName = '',
    className = '',
    overrideClasses = null,
    wrapperTag = 'div',
    formControlColor = 'text-gray-darker',
    id = SelectDefaultProps.id,
    toggle = SelectDefaultProps.toggle,
    isFirstOptionDisabled = SelectDefaultProps.isFirstOptionDisabled,
    options = SelectDefaultProps.options,
    optionsGrouped = SelectDefaultProps.optionsGrouped,
    valueKey = SelectDefaultProps.valueKey,
    labelKey = SelectDefaultProps.labelKey,
    value = SelectDefaultProps.value,
    preSavedValue = SelectDefaultProps.preSavedValue,
    defaultValue = SelectDefaultProps.defaultValue,
    disabled = SelectDefaultProps.disabled,
    onFocus = SelectDefaultProps.onFocus,
    isLabelHidden = SelectDefaultProps.isLabelHidden,
    labelText = SelectDefaultProps.labelText,
    labelClassName = SelectDefaultProps.labelClassName,
    toggleClassName = SelectDefaultProps.toggleClassName,
    optionClassName = SelectDefaultProps.optionClassName,
    inputClassName = SelectDefaultProps.inputClassName,
    hasOptionTruncate = SelectDefaultProps.hasOptionTruncate,
    'data-tracking-id': dataTrackingId = SelectDefaultProps['data-tracking-id'],
    'data-tracking-value': dataTrackingValue = SelectDefaultProps['data-tracking-value'],
    'data-no-refresh': dataNoRefresh = SelectDefaultProps['data-no-refresh'],
    'data-testid': dataTestid = SelectDefaultProps['data-testid'],
    ariaDescribedBy = SelectDefaultProps.ariaDescribedBy,
    ariaDescribedByAdditional = SelectDefaultProps.ariaDescribedByAdditional,
    ariaInvalid = SelectDefaultProps.ariaInvalid,
    enableSpinner = SelectDefaultProps.enableSpinner,
    useFloatingLabel = SelectDefaultProps.useFloatingLabel,
    moveFloatingLabelBack = SelectDefaultProps.moveFloatingLabelBack,
    labelAddon = SelectDefaultProps.labelAddon,
    'aria-required': ariaRequired = SelectDefaultProps['aria-required'],
    required = SelectDefaultProps.required,
    ...restProps
  },
  ref
) => {
  const props = {
    ...restProps,
    id,
    toggle,
    isFirstOptionDisabled,
    options,
    optionsGrouped,
    valueKey,
    labelKey,
    value,
    preSavedValue,
    defaultValue,
    disabled,
    onFocus,
    isLabelHidden,
    labelText,
    labelClassName,
    toggleClassName,
    optionClassName,
    inputClassName,
    hasOptionTruncate,
    'data-tracking-id': dataTrackingId,
    'data-tracking-value': dataTrackingValue,
    'data-no-refresh': dataNoRefresh,
    'data-testid': dataTestid,
    ariaDescribedBy,
    ariaDescribedByAdditional,
    ariaInvalid,
    enableSpinner,
    useFloatingLabel,
    moveFloatingLabelBack,
    labelAddon,
    'aria-required': ariaRequired,
    required,
  };

  const classes = classnames('form-control py-0_5 pe-2_5 size-16', formControlColor, className);
  const Tag = wrapperTag;

  return (
    <Tag
      className={classnames('styled-select chevron', wrapperClassName, {
        'size-lg': size === 'lg',
        'floating-label': useFloatingLabel,
        'select-disabled': isSelectDisabled({ optionsGrouped, options, preSavedValue, disabled }),
      })}
    >
      <Select className={overrideClasses || classes} ref={ref} {...props} />
    </Tag>
  );
};

export const StyledSelectPropTypes = {
  ...SelectPropTypes,
  size: PropTypes.oneOf(['lg']),
  wrapperClassName: PropTypes.string,
  className: PropTypes.string,
  overrideClasses: PropTypes.string,
  wrapperTag: PropTypes.string,
  formControlColor: PropTypes.string,
};

export const StyledSelect = forwardRef(StyledSelectUI);

StyledSelect.propTypes = {
  ...StyledSelectPropTypes,
};

StyledSelectUI.propTypes = {
  ...StyledSelectPropTypes,
};
